<script setup lang="ts">
import type { SectionStructuredTextRecord } from '~/types/datocms'

const props = defineProps<{
  data: SectionStructuredTextRecord
  moduleIndex: number
}>()

const { level, isSemantic } = useSectionRules(props.moduleIndex, !!props.data.title)
</script>

<template>
  <div class="container my-12 lg:my-20">
    <Heading
      v-if="data.title"
      :level="level"
      :size="3"
      :is-semantic="isSemantic"
      class="mb-4 lg:mb-8"
      >{{ data.title }}</Heading
    >
    <div v-if="data.subtitle" class="mb-8 lg:mb-10" v-html="data.subtitle" />
    <StructuredText v-if="data.structuredText" :data="data.structuredText" />
  </div>
</template>
